module.exports = __webpack_public_path__ + "assets/measure_account_trends.7902408c.svg";